import React from 'react'
import { format_day } from '../../utils/util'
import { ReactComponent as ChatTransparent } from '../../svg/normalSvgs/ChatTransparent.svg'
import { ReactComponent as CloseAye } from '../../assets/svg/CloseAye.svg'
import LetterIcon from '../../svg/LetterIcon'
import { useUser } from '../../context/user'
import { useTranslation } from 'react-i18next'
import i18n from '../../i18n'

const MessageStatusText = ({ text, visibleChats }) => {
    const isNew = text.toLowerCase().includes('new message')
    return (
        <div className="message-status-text">
            {isNew && <LetterIcon color="#F47C39" width={11} height={11} style={{ paddingRight: '5px' }} />}
            <div className={`conversation-status ${isNew ? 'new-message-text' : visibleChats ? '' : 'message-white-text'}`}>{text}</div>
        </div>
    )
}

export default function ChatListItem({ conversation, selectedChat, selectChatExternally, visibleChats }) {
    const { user } = useUser()
    const { t } = useTranslation()
    const locale = i18n.language

    const date = format_day(conversation?.last_message.created_date, true, locale)
    const bg = conversation.color
    const otherMemberNames = Object.entries(conversation.names || {})
        .filter(([id]) => id !== user.id)
        .map(([, memberName]) => memberName)
        .join(', ')
    const name = (user.role === 0 ? conversation.label_for_student : conversation.label_for_teacher) || otherMemberNames
    const isNewMessage = !conversation?.last_message?.seen?.includes(user.id) && conversation.last_message.user_id !== user.id
    const receivedMessage = user.id !== conversation.last_message.user_id
    const status = receivedMessage ? (isNewMessage ? t('newMessage') : t('Received')) : conversation.last_message.status

    return (
        <div className={`chat-item ${selectedChat?.conversation_id === conversation?.conversation_id ? 'selected-chat' : ''}`} onClick={() => selectChatExternally(conversation)}>
            <div className="chat-icon">
                <div className={`chat-icon-circle`} style={{ backgroundColor: bg }}>
                    <ChatTransparent style={{ color: conversation.conversation_type === 'teacher' ? '#153c4f' : '#F8F8FB' }} />
                </div>
            </div>
            <div className="chat-details">
                <div className="chat-name">
                    <div className="chat-name-text" style={{ color: visibleChats ? '#153c4f' : '#ffffff' }}>
                        {t(name)}
                    </div>
                    {!visibleChats && <CloseAye />}
                </div>
                <div className="chat-status">
                    <MessageStatusText text={t(status)} visibleChats={visibleChats} />
                    <span className="chat-status-item">{date}</span>
                </div>
            </div>
        </div>
    )
}
